import { GALLERY } from "../../data";
import { SectionHeading, Reveal } from "./Shared";

const spanClass = (span) => {
  if (span === "tall") return "row-span-2";
  if (span === "wide") return "md:col-span-2";
  return "";
};

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-28 px-6 bg-[#2d3a1f]"
    >
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="The Gallery"
          title="Moments of Stillness"
          subtitle="A glimpse into the calm, botanical world of Royale."
        />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 auto-rows-[240px] gap-4">
          {GALLERY.map((g, i) => (
            <Reveal
              key={i}
              delay={(i % 3) * 0.08}
              className={`gallery-item relative overflow-hidden group ${spanClass(g.span)}`}
            >
              <div data-testid={`gallery-item-${i}`} className="w-full h-full">
                <img
                  src={g.img}
                  alt={g.alt}
                  className="gallery-img w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-[#151c0f]/0 group-hover:bg-[#151c0f]/25 transition-colors duration-500" />
                <div className="absolute inset-0 ring-1 ring-inset ring-[#b89d62]/0 group-hover:ring-[#b89d62]/40 transition-all duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
